import React, { useEffect, useState } from "react";
import Reactportal from "../../../Components/Reactportal/Reactportal";
import styled from "styled-components";
import { GoArrowRight } from "react-icons/go";
import PortalFooter from "../../../Components/Reactportal/PortalFooter";
import { useMutation } from "@apollo/client";
import { DeleteColumInTaskmanagement, GET_ALL_TASKS, GET_BOARD_BY_ID } from "../utils/quires";
import { ErrorToast, SuccessToast } from "../../../Components/ToastComponent/RectHotToast";
import Select from "react-select";
const customStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: "40px",
    borderColor: state.isFocused ? "#666" : base.borderColor,
    boxShadow: state.isFocused ? "0 0 0 1px #666" : "none",
    "&:hover": {
      borderColor: state.isFocused ? "#666" : "#ccc",
    },
  }),
  valueContainer: (base) => ({
    ...base,
    padding: "0 8px",
  }),
  input: (base) => ({
    ...base,
    margin: 0,
    padding: 0,
    width: "200px",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: "4px",
  }),
  clearIndicator: (base) => ({
    ...base,
    padding: "4px",
  }),
  menu: (base) => ({
    ...base,
    margin: 0,
  }),
  menuList: (base) => ({
    ...base,
    paddingTop: 0,
    paddingBottom: 0,
  }),
  // option: (base, state) => ({
  //   ...base,
  //   backgroundColor: state.isSelected ? '#2ca01c' : 'white',
  //   color: 'black',
  //   '&:hover': {
  //     backgroundColor: '#f0f0f0'
  //   }
  // }),
};

const DeleteModal = ({ open, onClose, ColumnData, ColumnID, BoardID, tasks }) => {
  const [columns, setColumns] = useState(null);
  const [MoveColumn, setMoveColumn] = useState(null);
  const [SelcolumnData, setColumnTitle] = useState(null);
  const [DropData, setDropData] = useState([]);
  const [selectedColumn, setSelectedColumn] = useState(null);

  const [DeleteColumInBoard] = useMutation(DeleteColumInTaskmanagement, {
    onCompleted: () => {
      SuccessToast(`Column Deleted successfully cards are moved to ${MoveColumn?.Title}`);
    },
    onError: (err) => {
      ErrorToast("Failed to Delete Column : " + err.message);
    },
    refetchQueries: [
      {
        query: GET_ALL_TASKS,
        variables: {
          userInput: {
            Board_ID: BoardID,
            User: [],
            keyword: "",
          },
        },
        fetchPolicy: "network-only",
      },
      { query: GET_BOARD_BY_ID, variables: { id: BoardID, fetchPolicy: "network-only" } },
    ],
  });
  useEffect(() => {
    const filteredColumns = ColumnData?.filter((ele) => ele._id !== ColumnID).map((ele) => ({
      label: ele.Title,
      value: ele._id,
    }));
    setDropData(filteredColumns);
    if (filteredColumns.length > 0) {
      setSelectedColumn(filteredColumns[0]);
    }
  }, [ColumnID, ColumnData]);
  useEffect(() => {
    const data = ColumnData?.find((ele) => ColumnID === ele?._id);
    const columns = ColumnData?.filter((ele) => ele?._id !== ColumnID).map((ele) => ({
      Title: ele?.Title, // Specify keys for the object
      _id: ele?._id,
    }));
    setColumns(columns);
    if (columns?.length) {
      setMoveColumn(columns[0]);
    }
    if (data) {
      setColumnTitle(data);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ColumnID]);

  const handleMergeColumn = async () => {
    // const mapingTaks = [...tasks[ColumnID], ...tasks[SelcolumnData._id]];
    // const data = mapingTaks.map((ele, index) => {
    //   return {
    //     _id: ele._id,
    //     Serial_No: index,
    //     Column_ID: SelcolumnData._id,
    //   };
    // });
  
    await DeleteColumInBoard({
      variables: {
        boardId: BoardID,
        deleteColumnId: ColumnID,
        newColumnId: selectedColumn?.value,
      },
    });
    onClose();
  };
  return (
    <div>
      <Reactportal open={open} onClose={onClose}>
        <ParentContainer>
          <ModelHeader>
            Move work from <span className="delete"> {SelcolumnData?.Title}</span> column
            {/* <span className="update"> DONE</span> */}
          </ModelHeader>
          <TextContainer>
            {" "}
            The selected column will be deleted, but any existing tasks in the column will be moved to the selected
            column.
          </TextContainer>
          <FlexContainer>
            <TaskConatainer>
              <span className="status-text">This status will be deleted :</span>
              <p className="status-underline">{SelcolumnData?.Title}</p>
            </TaskConatainer>
            <TaskConatainer className="input-container">
              {/* <span className="status-text">Move existing cards to:</span> */}
              <GoArrowRight size={20} className="arrow-icon" />
              {/* <Input
                value={MoveColumn?.Title}
                name="cardsData"
                modalform={true}
                type={"inpdrop"}
                label={"Move existing cards to:"}
                dropdowndata={columns}
                handleBlur={() => {}}
                handleInputChange={(e) => {
                  setMoveColumn(e.target.value);
                }}
                notSearchable={true}
              /> */}
              <Select
                className="react-select-container"
                classNamePrefix="react-select"
                options={DropData}
                value={selectedColumn}
                onChange={setSelectedColumn}
                styles={customStyles}
              />
            </TaskConatainer>
          </FlexContainer>
        </ParentContainer>
        <PortalFooter SaveAndClose={handleMergeColumn} handleformclose={onClose} />
      </Reactportal>
    </div>
  );
};

export default DeleteModal;

const ParentContainer = styled.div`
  padding: 1rem;
  padding-top: 0.5rem;
  display: flex;
  flex-direction: column;
  /* column-gap: 0.5rem; */
  width: 600px;

  .input-container {
    display: flex;
    flex-direction: row;
    width: 40%;

    /* input {
      width: 200px;
    } */
    .form__label {
      font-size: 0.8rem;
      font-weight: 600;
      color: #172b4d;
      margin-top: -5px;
    }
  }
`;
const ModelHeader = styled.p`
  color: #172b4d;
  font-size: 1.2rem;
  font-weight: bold;
  .delete {
    color: red;
  }
  .update {
    color: green;
  }
`;
const TextContainer = styled.p`
  font-size: 1rem;
`;

const FlexContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
const TaskConatainer = styled.div`
  display: flex;
  flex-direction: column;
  /* gap: 20px; */
  .status-text {
    font-size: 0.8rem;
    font-weight: 600;
    color: #172b4d;
  }
  .status-underline {
    text-decoration: line-through;
    color: red;
    margin-left: 5px;
    margin-top: -1px;
  }
  .arrow-icon {
    /* margin-left: -25px; */
    margin-top: 12px;
  }
`;
